import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { PointofsaleService } from '../api/pointofsale/pointofsale.service';
import { ToolsService } from '../tools/tools.service';
import { JsonLDService } from '../manage/meta-ldjson/ld-json';
import { TableReservationService } from '../api/table-reservation/table-reservation.service';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LangagesService } from '../manage/langages/langages.service';
import {ContextAppService} from "../context-app-service";

@Injectable({
  providedIn: 'root'
})

export class MetaTitleGuard implements CanActivate {

  constructor(
    private metaTitle: Title,
    private meta: Meta,
    private posService: PointofsaleService,
    private tools: ToolsService,
    private trService: TableReservationService,
    private ld: JsonLDService,
    private contextAppService: ContextAppService,
    @Inject(DOCUMENT) private _document: Document,
    public translate: TranslateService,
    public LangagesService:LangagesService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const that = this;

    return new Promise(function (resolve) {

      const r:any = next.queryParamMap;

      const params:any = next.params;


      const path:any = next.routeConfig?next.routeConfig.path:null;
      const urlName:any = next.url[0].path;

      const pointOfSale:any = that.tools.getStor("point_of_sale");

      if (params.posId) {
        resolve(true);
      }

      else if (params.webshopId) {
        // console.log("params.webshopId")

        /**
         * booking meta and ld json
         */
        if (urlName === 'tr') {
          that.trService.$_getBookingMeta(params.webshopId)
                   .then(MetaData => {
                  //  //new
                  //  if(MetaData && MetaData.code<0){
                  //   return
                  //   resolve(false);
                  // }

              if (MetaData.object.klixi_aysbe_providerId) {
                that.ld.insertKlixiScript(MetaData);
              }

              /**
               * Set meta
               */
              that.setMetaDataByMetaData(MetaData.object);

              /**
               * Set ldjson
               */
              that.ld.insertSchema(MetaData.object.ld_json);

              resolve(true);
            })

        }

        else {

          that.posService.$_getUserKeyByWebShopId(params.webshopId,'guardmetatitle').then((keyData: any) => {
            // console.log(keyData)

            // On stocke le point de vente en cours
            that.contextAppService.webshopId = params.webshopId
            that.contextAppService.currentPointOfSale = keyData.object.point_of_sale

            // Set title
            that.setMetaDataByMetaData(keyData.object);

            //set ldjson
            that.ld.insertSchema(keyData.object.ld_json);

            resolve(true);
          })
        }

      } else if (params.merchantId) {


        that.posService.$_getUserKeyByMerchantId(params.merchantId).then(keyData => {
          // Set title
          that.setMetaDataByMetaData(keyData.object);

          //set ldjson
          that.ld.insertSchema(keyData.object.ld_json);

          resolve(true);

        })

      }

      else if (params.orderId) {
        resolve(true);
      }

      else if (path.includes("endorder")) {
        /**
         * Set meta data by user account
         */
        let lang=that.LangagesService.getInternetLang();
        let meta=that.LangagesService.getmeta(lang);
        that.setMetaDataByUserAccount(pointOfSale.name_webshop,meta.thankorder,meta);
        //set ldjson reset
        that.ld.insertSchema();
        resolve(true);
      } else if (urlName === "product" || urlName === "s" || urlName === "note")  {
        if (pointOfSale) {
          /**
           * Set meta data by user account
           */
          that.setMetaDataByUserAccount(pointOfSale.name_webshop);


          //set ldjson reset
          that.ld.insertSchema();
        }

        resolve(true);

      }


    })

  }


  /**
   * @description Set tous les meta tags en unitilisant le nom d'un commerçant ou d'un point de vente
   * @param {string} name
   * @return {void}
   */
  setMetaDataByUserAccount(name: string, supp?: string, metaTitle?:any): void {

    if(!metaTitle)
      return;


    this.metaTitle.setTitle(name + " - " + (supp ? supp : "WEBSHOP"));

    //lang du navigateur

    this.meta.updateTag({ itemprop: 'name', content: name + metaTitle.online  });
    this.meta.updateTag({ itemprop: 'description', content: metaTitle.ordernow  + name });
    this.meta.updateTag({ itemprop: 'image', content: "" });

    this.meta.updateTag({ property: 'og:site_name', content: "Webshop, Fülle" });
    this.meta.updateTag({ property: 'og:title', content: name + metaTitle.online  });
    this.meta.updateTag({ property: 'og:description', content: metaTitle.ordernow + name });
    this.meta.updateTag({ property: 'og:type', content: "website" });
    this.meta.updateTag({ property: 'og:image', content: "" });

    this.meta.updateTag({ property: 'og:url', content: window.location.hostname });

    this.meta.updateTag({ property: 'twitter:card', content: "summary_large_image" });
    this.meta.updateTag({ property: 'twitter:title', content: name + metaTitle.online  });
    this.meta.updateTag({ property: 'twitter:image', content: "" });
    this.meta.updateTag({ property: 'twitter:image:alt', content: metaTitle.img });
  }

  /**
 * @description Set tous les meta tags dynamiquement avec les donnés récupérées de la requete meta
 * @param {metaData} any
 * @return {void}
 */
  setMetaDataByMetaData(metaData: any): void {

    this.metaTitle.setTitle(metaData.og_title);

    this.meta.updateTag({ property: 'name', content: metaData.title });
    this.meta.updateTag({ property: 'description', content: metaData.description });

    this.meta.updateTag({ property: 'og:title', content: metaData.og_title });
    this.meta.updateTag({ property: 'og:description', content: metaData.og_description });
    this.meta.updateTag({ property: 'og:type', content: metaData.og_type });
    this.meta.updateTag({ property: 'og:image', content: metaData.og_image });
    this.meta.updateTag({ property: 'og:url', content: metaData.http_origin });
    this.meta.updateTag({ property: 'og:locale', content: metaData.og_locale });

    this.meta.updateTag({ property: 'twitter:card', content: metaData.twitter_card });
    this.meta.updateTag({ property: 'twitter:description', content: metaData.twitter_description });
    this.meta.updateTag({ property: 'twitter:title', content: metaData.twitter_title });
    this.meta.updateTag({ property: 'twitter:image', content: metaData.og_image });
    this.meta.updateTag({ property: 'twitter:image:alt', content: metaData.twitter_image_alt });
  }


}
